import { __awaiter } from "tslib";
import Vue from 'vue';
export default Vue.extend({
    props: {
        selectedItems: {
            type: Array,
            required: true
        },
        asideIsOpened: {
            type: Boolean,
            required: true
        },
        haveSelectedFolders: {
            type: Boolean,
            required: true
        },
        letMoveFolderUp: {
            type: Boolean,
            required: true
        },
        letMoveFolderDown: {
            type: Boolean,
            required: true
        },
        letDeleteItemFromFolder: {
            type: Boolean,
            required: true
        },
        availableToMoveFolders: {
            type: Array,
            required: true
        },
        automaticLeverage: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        searchPhrase: '',
        automaticLeverageValue: false,
        leveragesFaqLink: ''
    }),
    computed: {
        computedMoveFolderDirectionsList() {
            const result = [];
            if (this.letMoveFolderUp)
                result.push({ key: 'up', value: this.$t('leveragesPage.moveUp') });
            if (this.letMoveFolderDown)
                result.push({ key: 'down', value: this.$t('leveragesPage.moveDown') });
            return result;
        }
    },
    filters: {
        transformedAvailableToMoveFolders(value) {
            return value.map((folder) => ({ value: folder.name, key: folder.index }));
        }
    },
    methods: {
        getLeveragesFaqLink() {
            return __awaiter(this, void 0, void 0, function* () {
                const slug = 'leverages';
                const vm = this;
                const { data } = yield vm.services.mainService.getFaqLinkBySlugName(slug);
                this.leveragesFaqLink = data[slug].link;
            });
        },
        openOptimalLeverageHandler() {
            const showNoMoreOptimalLeverage = localStorage.getItem('showNoMoreOptimalLeverage');
            if (showNoMoreOptimalLeverage || this.selectedItems.length === 1) {
                this.$emit('onOptimalLeverageSet');
                return;
            }
            this.$emit('changeOptimalLeveragesPopup', true);
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'confirmPopup',
                title: 'Оптимальные плечи',
                slot: {
                    name: 'setOptimalLeveragesPopupChunk',
                    data: {
                        leveragesFaqLink: vm.leveragesFaqLink
                    }
                },
                actions: [
                    {
                        title: 'Применить плечи',
                        isAccent: true,
                        callback() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('onOptimalLeverageSet');
                            vm.$emit('changeOptimalLeveragesPopup', false);
                        }
                    },
                    {
                        title: 'Отмена',
                        isAccent: false,
                        callback() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('changeOptimalLeveragesPopup', false);
                        }
                    }
                ]
            });
        }
    },
    beforeMount() {
        this.getLeveragesFaqLink();
    },
    mounted() {
        this.automaticLeverageValue = this.automaticLeverage;
    },
    watch: {
        automaticLeverage(value) {
            this.automaticLeverageValue = value;
        },
        automaticLeverageValue(value) {
            this.$emit('onAutomaticLeverageChange', value);
        }
    }
});
